import { render, staticRenderFns } from "./form4.vue?vue&type=template&id=53f1efe1&scoped=true&"
import script from "./form4.vue?vue&type=script&lang=js&"
export * from "./form4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1efe1",
  null
  
)

export default component.exports